import React, { FC, useRef } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { Journey } from 'src/common/interfaces/journey.interface';
import { functionNoop } from 'src/utils/function/noop';
import { JourneyMenu } from 'src/common/JourneyMenu';
import { generateJourneyAliasShareUrl } from 'src/utils/journey';
import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';
import { LinkRegularIcon } from 'src/monet/icons';
import { useSharePanelStore } from 'src/common/store/share.store';

interface DashboardHomeJourneysCopyLinksMenuProps {
  journey: Journey;
  renderMenuOrigin: (onClick: any) => any;
  onOpen: () => void;
  onClose: () => void;
  onCopy: () => void;
}

export const DashboardHomeJourneysCopyLinksMenu: FC<DashboardHomeJourneysCopyLinksMenuProps> = ({
  journey,
  renderMenuOrigin,
  onOpen,
  onClose,
  onCopy,
}) => {
  const onJourneyShareOpen = useSharePanelStore((state) => state.onJourneyShareOpen);

  const menuOpenRef = useRef(functionNoop);
  const menuCloseRef = useRef(functionNoop);

  const onMenuClicked = () => {
    menuOpenRef.current();
  };

  const onEditLinksClicked = () => {
    onJourneyShareOpen(journey);
    menuCloseRef.current();
  };

  const menuItemClasses = 'text-bedrock-p text-bedrock-black flex items-start space-x-sm text-left';

  return (
    <JourneyMenu
      placement='bottom-start'
      containerClassName='w-60 pt-md max-h-[420px] overflow-y-auto'
      openRef={menuOpenRef}
      closeRef={menuCloseRef}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={() => renderMenuOrigin(onMenuClicked)}
      footer={<div onClick={onEditLinksClicked}>Edit links</div>}
    >
      {journey.aliases.map((alias: JourneyAlias) => (
        <CopyToClipboard
          key={alias.id}
          text={generateJourneyAliasShareUrl(journey.organization, alias.slug)}
          onCopy={onCopy}
        >
          <JourneyMenu.Item key={`copy-link-${alias.id}`} className={menuItemClasses}>
            <LinkRegularIcon className='shrink-0' />
            <div className='text-bedrock-p'>{alias.name}</div>
          </JourneyMenu.Item>
        </CopyToClipboard>
      ))}
    </JourneyMenu>
  );
};
